// extracted by mini-css-extract-plugin
module.exports = {"infoValueContainer":"_uM","color":"_uN","circle":"_uO"};